<template>
  <span>
    <slot
      :hour="countTime.hour"
      :minute="countTime.minute"
      :second="countTime.second"
      :isEnd="isEnd"
    />
  </span>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'Countdown',
  props: {
    endTime: [String, Number]
  },
  data () {
    return {
      countdownData: window.countdownData,
      emitedCountdownEnd: false
    }
  },
  computed: {
    countTime () {
      const endTime = dayjs(this.endTime)
      const curTime = dayjs(this.countdownData.currTime)
      let hour = 0
      let minute = 0
      let second = 0

      const ms = endTime.diff(curTime)
      if (ms > 0) {
        hour = endTime.diff(curTime, 'hour')
        minute = endTime.diff(curTime, 'minute') - hour * 60
        second = endTime.diff(curTime, 'second') - hour * 60 * 60 - minute * 60
      } else {
        this.handleEnd()
      }
      return {
        hour: String(hour).padStart(2, '0'),
        minute: String(minute).padStart(2, '0'),
        second: String(second).padStart(2, '0'),
      }
    },
    isEnd () {
      return this.countTime.hour === '00' && this.countTime.minute === '00' && this.countTime.second === '00'
    }
  },
  methods: {
    async handleEnd () {
      await this.$nextTick()
      if (!this.emitedCountdownEnd) {
        this.emitedCountdownEnd = true
        this.$emit('countdownEnd')
      }
    }
  },
}
</script>
